import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import logo from "../../assets/images/logo.png";
import logo1 from "../../assets/images/brand-logos/desktop-dark.png";
import Img from "../../assets/images/flags/us_flag.jpg";
import Img1 from "../../assets/images/flags/french_flag.jpg";
import { PhoneInput } from "react-international-phone";
import "react-international-phone/style.css";
import Spinner from "../../components/LoadingSpinner/loadingSpinner";
import axios from "axios";
import { FaArrowLeft } from "react-icons/fa6";
import { RiEyeLine, RiEyeOffLine } from "react-icons/ri";
import Cookies from "js-cookie";
import api from "../../api";
import { useNavigate } from "react-router-dom";
import { useSearchParams } from "react-router-dom";
import Swal from "sweetalert2";
import { parsePhoneNumberFromString } from "libphonenumber-js";
const Signup = () => {
  const navigate = useNavigate();
  const [step, setStep] = useState(1);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [countryData, setCountryData] = useState(null);
  const [languageData, setLanguageData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showSpinner, setShowSpinner] = useState(false);
  const [email, setEmail] = useState("");
  const [termsChecked, setTermsChecked] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [pseudo, setPseudo] = useState("");
  const [password, setPassword] = useState("");
  const [birthdate, setBirthdate] = React.useState({
    day: "",
    month: "",
    year: "",
  });
    const [cookieLang, setCookieLang] = useState("");
  const [errors, setErrors] = useState({});
  const [sponsorshipCode, setSponsorshipCode] = useState("");
  const [searchParams] = useSearchParams();
  const sponsorshipFromUrl = searchParams.get("sponsorship") || "";
  const finalSponsorshipCode = sponsorshipCode.trim() || sponsorshipFromUrl;

  function setLanguage(lang) {
    document.cookie = `lang=${lang}; path=/; max-age=31536000`;
    localStorage.setItem("lang", lang);
 //   window.location.reload();
  }
  useEffect(() => {
    const token = localStorage.getItem(`${process.env.REACT_APP_LOCAL_TOKEN}`);
    if (token) {
      navigate("/", { replace: true });
    }
  }, []);
  useEffect(() => {
  const observer = new MutationObserver(() => {
    const button = document.querySelector(
      ".react-international-phone-country-selector-button"
    );

    if (button) {
      button.setAttribute("data-interaction", "country_dropdown");
      observer.disconnect();
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });

  return () => observer.disconnect();
}, []);
  useEffect(() => {
    const defaultLang = process.env.REACT_APP_LANG;
    const cookieLang =
      localStorage.getItem("lang") ||
      document.cookie
        .split("; ")
        .find((row) => row.startsWith("lang="))
        ?.split("=")[1] ||
      defaultLang;

    if (cookieLang) {
      setCookieLang(cookieLang);
      import(`../../lang/signup/${cookieLang}.json`)
        .then((data) => {
          setLanguageData(data.default);
        })
        .catch((error) => {
          console.error("Error loading language file:", error);
        });
    } else {
      console.error("Language cookie 'lang' not found.");
    }
  }, []);
  const getDevice = () => {
    const ua = navigator.userAgent;

    if (/mobile/i.test(ua)) return "Mobile";
    if (/tablet/i.test(ua)) return "Tablet";
    return "Desktop";
  };
  const getBrowserInfo = () => {
    const ua = navigator.userAgent;
    let browser = "Unknown";
    let version = "Unknown";

    if (ua.includes("Chrome")) {
      browser = "Chrome";
      version = ua.match(/Chrome\/([\d.]+)/)?.[1];
    } else if (ua.includes("Firefox")) {
      browser = "Firefox";
      version = ua.match(/Firefox\/([\d.]+)/)?.[1];
    } else if (ua.includes("Safari")) {
      browser = "Safari";
      version = ua.match(/Version\/([\d.]+)/)?.[1];
    } else if (ua.includes("Edg")) {
      browser = "Edge";
      version = ua.match(/Edg\/([\d.]+)/)?.[1];
    }

    return { browser, version };
  };
  const getOSInfo = () => {
    const ua = navigator.userAgent;
    let os = "Unknown";
    let version = "Unknown";

    if (ua.includes("Windows")) {
      os = "Windows";
      version = ua.match(/Windows NT ([\d.]+)/)?.[1];
    } else if (ua.includes("Mac OS")) {
      os = "OS X";
      version = ua.match(/Mac OS X ([\d_]+)/)?.[1]?.replace(/_/g, ".");
    } else if (ua.includes("Android")) {
      os = "Android";
      version = ua.match(/Android ([\d.]+)/)?.[1];
    } else if (ua.includes("iPhone")) {
      os = "iOS";
      version = ua.match(/OS ([\d_]+)/)?.[1]?.replace(/_/g, ".");
    }

    return { os, version };
  };

  async function getUserCountryOnce() {
    const cached = localStorage.getItem("userCountry");
    if (cached) return JSON.parse(cached);

    try {
      const ipRes = await fetch("https://api.ipify.org?format=json");
      const ipData = await ipRes.json();

      const lookupRes = await fetch(
        "https://builder.leadsy.pro/lookup_api/v1/" + ipData.ip,
      );

      const lookupData = await lookupRes.json();
      const data = lookupData?.data || {};

      const result = {
        ip: data.ip || ipData.ip,
        city: data.city || "Unknown City",
        region: data.region || "Unknown Region",
        country: data.country || "Unknown",
        timezone:
          data.timezone || Intl.DateTimeFormat().resolvedOptions().timeZone,
      };
      const country = lookupData?.data?.country || "us";
      localStorage.setItem("userCountry", JSON.stringify(result));

      return result;
    } catch (e) {
      return {
        ip: "",
        city: "Unknown City",
        region: "Unknown Region",
        country: "US",
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      };
    }
  }
  const { browser, version } = getBrowserInfo();
  const { os, version: osVersion } = getOSInfo();
  const init = async () => {
    const locationData = await getUserCountryOnce();
         const leadId = Cookies.get(process.env.REACT_APP_LEAD_ID_PLATFORM) || Cookies.get(process.env.REACT_APP_LEAD_ID);
    const payload = {
      url: window.location.href,
      device: getDevice(),
      ip_address: locationData.ip,
      browser_data: navigator.userAgent,
        ...(leadId ? { lead_id: leadId } : {}),
      details: {
        browser: browser,
        browser_version: version,
        operating_system: os,
        operating_system_version: osVersion,
        location: `${locationData.region}`,
        city: locationData.city,
        region: locationData.region,
        country: locationData.country,
        timezone: locationData.timezone,
        use_vpn: false,
      },
    };
    return payload;
  };

  async function updateSessionLead(lead_id, payload) {
    try {
      const response = await api.post(
        `${process.env.REACT_APP_BASE_URL}/tracking/sessions/add`,
        {
          ...payload,
          lead_id: lead_id,
        },
      );
      const data = response.data;
      Cookies.set(`${process.env.REACT_APP_SESSION_ID}`, String(data.data.id));
      Cookies.set(
        `${process.env.REACT_APP_LEAD_ID}`,
        String(data.data.lead_id),
      );
      Cookies.set(
        `${process.env.REACT_APP_SESSION_ID}_expires`,
        String(Date.now()),
      );
      return response;
    } catch (err) {
      console.error("Update session error:", err);
      return null;
    }
  }
   const getSessionId = async (payload) => {
      let sessionId = Cookies.get(process.env.REACT_APP_SESSION_ID);
  
      const expiredSession = Cookies.get(
        `${process.env.REACT_APP_SESSION_ID}_expires`,
      );
  
      const isExpired =
        !expiredSession || Date.now() - Number(expiredSession) > 3600000;
  
      if (!sessionId || isExpired) {
        const leadId =
          Cookies.get(process.env.REACT_APP_LEAD_ID_PLATFORM) ||
          Cookies.get(process.env.REACT_APP_LEAD_ID);
  
        const response = await updateSessionLead(leadId, payload);
  
        if (!response) return null;
  
        sessionId = String(response.data.data.id);
      }
  
      return sessionId;
    };
 const trackInteraction = async (
    action,
    element,
    element_value,
    time_start = new Date().toISOString(),
    time_end = new Date().toISOString(),
    payload = null,
  ) => {
    try {
      const sessionId = await getSessionId(payload);

      if (!sessionId) return;

      await api.post(
        `${process.env.REACT_APP_BASE_URL}/tracking/interactions/add`,
        {
          session_id: sessionId,
          action,
          element,
          element_value: element_value || "",
          time_start,
          time_end,
        },
      );
    } catch (error) {
      console.error("Tracking error:", error);
    }
  };
  useEffect(() => {
    const runTracking = async () => {
      const payload = await init();
      await getSessionId(payload);
      await trackInteraction(
        "view",
        "page_load",
        window.location.href,
        new Date().toISOString(),
        new Date().toISOString(),
        payload,
      );
    };

    runTracking();
  }, []);

  useEffect(() => {
    const handleSubmit = async (e) => {
      const form = e.target;
      const now = new Date().toISOString();
      await trackInteraction(
        "submit",
         form.name,
        now,
        now
      );
    };

    const handleClick = async (e) => {
      const button = e.target.closest("button, a");
      if (!button) return;
      const now = new Date().toISOString();
      await trackInteraction(
        "click",
         button.dataset.interaction,
        button.textContent,
        now,
        now
      );
    };

    const handleBlur = async (e) => {
      if (!["INPUT", "SELECT", "TEXTAREA"].includes(e.target.tagName)) return;
      const now = new Date().toISOString();
      await trackInteraction(
        "input",
          e.target.name,
      e.target.value,
        now,
        now
      );
    };

    document.addEventListener("submit", handleSubmit);
    document.addEventListener("click", handleClick);
    document.addEventListener("blur", handleBlur, true);

    return () => {
      document.removeEventListener("submit", handleSubmit);
      document.removeEventListener("click", handleClick);
      document.removeEventListener("blur", handleBlur, true);
    };
  }, []);
  
  async function trackSession(payload) {
    const existingSessionId = Cookies.get(
      `${process.env.REACT_APP_SESSION_ID}`,
    );

    if (existingSessionId) {
      return existingSessionId;
    }

    try {
      const response = await api.post(
        `${baseUrl}/tracking/sessions/add`,
        payload,
      );

      const data = response?.data?.data;

      if (!data) return null;

      Cookies.set(`${process.env.REACT_APP_LEAD_ID}`, String(data.lead_id), {
        path: "/",
      });

      Cookies.set(`${process.env.REACT_APP_SESSION_ID}`, String(data.id), {
        path: "/",
      });

      Cookies.set(
        `${process.env.REACT_APP_SESSION_ID}_expires`,
        String(Date.now()),
        {
          path: "/",
        },
      );

      return String(data.id);
    } catch (err) {
      console.error("Tracking session error:", err);
      return null;
    }
  }
    const createSession = async () => {
       const existingSessionId = Cookies.get(process.env.REACT_APP_SESSION_ID);
  
    if (existingSessionId) {
      return existingSessionId;
    }
  
    const payload = await init();
  
    if (!payload) return null;
  
    return await trackSession(payload);
    };
    
  if (!languageData) {
    return <div></div>;
  }

  const slideVariants = {
    hidden: { x: "100%", opacity: 0 },
    visible: { x: 0, opacity: 1 },
    exit: { x: "-100%", opacity: 0 },
  };
  const removeError = (field) => {
    setErrors((prev) => ({
      ...prev,
      [field]: "",
    }));
  };
  const validateStep1 = () => {
    const newErrors = {};
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!email.trim()) {
      newErrors.email = languageData["email-error"];
    } else if (!emailRegex.test(email)) {
      newErrors.email = languageData["email-invalid"];
    }
    if (!termsChecked) newErrors.terms = languageData.terms["terms-error"];
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const validateStep2 = () => {
    const newErrors = {};

    if (!pseudo.trim()) newErrors.pseudo = languageData["pseudo-error"];
    if (!password.trim()) newErrors.password = languageData["password-error"];

    const cleanedPhone = phoneNumber.replace(/\s/g, "");

    if (!cleanedPhone) {
      newErrors.phoneNumber = languageData["phone-error"];
    } else if (!/^\+?[1-9]\d{7,14}$/.test(cleanedPhone)) {
      newErrors.phoneNumber = languageData["phone-invalid"];
    }

    if (!birthdate.day || !birthdate.month || !birthdate.year) {
      newErrors.birthdate = languageData["birth-error"];
    } else {
      const birthDateObj = new Date(
        birthdate.year,
        birthdate.month - 1,
        birthdate.day,
      );

      const isValidDate =
        birthDateObj.getFullYear() === Number(birthdate.year) &&
        birthDateObj.getMonth() === Number(birthdate.month) - 1 &&
        birthDateObj.getDate() === Number(birthdate.day);

      if (!isValidDate) {
        newErrors.birthdate = languageData["birth-invalid"];
      } else {
        const today = new Date();

        let age = today.getFullYear() - birthDateObj.getFullYear();

        const monthDiff = today.getMonth() - birthDateObj.getMonth();

        if (
          monthDiff < 0 ||
          (monthDiff === 0 && today.getDate() < birthDateObj.getDate())
        ) {
          age--;
        }

        if (age < 18) {
          newErrors.birthdate = languageData["birth-req"];
        }
      }
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleContinueInscription = () => {
    if (validateStep1()) {
      setStep(2);
    }
  };
  const formattedBirthdate = `${birthdate.year}-${String(
    birthdate.month,
  ).padStart(2, "0")}-${String(birthdate.day).padStart(2, "0")}`;

  const baseUrl = process.env.REACT_APP_BASE_URL;
  const portalUrl = process.env.REACT_APP_APPLICATION;
  const session_id = Cookies.get(`${process.env.REACT_APP_SESSION_ID}`);

  const signUp = async () => {
    if (!validateStep2()) {
      return;
    }
    setLoading(true);
    try {
      const session_id = await createSession();
      const response = await api.post(
        `${baseUrl}/accounts/sign-up`,
        {
          source: portalUrl,
          login: email,
          password: password,
          pseudo: pseudo,
          birthdate: formattedBirthdate,
          country: countryData?.iso2?.toUpperCase(),
          session_id,
          phone: phoneNumber.replace(/\s/g, ""),
          ...(finalSponsorshipCode.trim() && {
            sponsorship_code: finalSponsorshipCode.trim(),
          }),
        }
      );
      localStorage.setItem(
        `${process.env.REACT_APP_LOCAL_TOKEN}`,
        JSON.stringify({
          token: response.data.data.token,
          expiresAt: Date.now() + 10 * 60 * 1000,
        }),
      );
      localStorage.setItem(
        `${process.env.REACT_APP_REFRESH_TOKEN}`,
        response.data.data.refresh_token,
      );
 localStorage.setItem(
  process.env.REACT_APP_USER_INFO,
  JSON.stringify({
     user_id: response.data.data.id,
        nickname: response.data.data.user.nickname,
        personal_code: response.data.data.personal_code,
  })
);

      const now = new Date().toISOString();
        await trackInteraction("register", "signup_page", `${response.data.data.id}`, now, now);
      //----sponsorship rewards---- //
      const rewards = response?.data?.data?.claimed_sponsorship_rewards || [];

      if (rewards.length) {
        localStorage.setItem(
          "signup_rewards_alert",
          JSON.stringify({
            show: true,
            rewards,
          }),
        );
      }

      //------redirect ----//
      const params = new URLSearchParams(window.location.search);

      const redirect = params.get("redirect");

      if (redirect) {
        window.location.href = redirect;
      } else {
        navigate("/");
      }
    } catch (error) {
      const details = error.response?.data?.details || [];

      const fieldErrors = {};

      details.forEach((err) => {
        if (!err.field) return;
        if (err.message === "phone must be a valid phone number") {
          fieldErrors[err.field] = languageData.phone_invalid;
        } else if (
          err.message === "pseudo must contain at least 3 characters"
        ) {
          fieldErrors[err.field] = languageData.pseudo_invalid;
        } else {
          fieldErrors[err.field] = err.message;
        }
      });

      setErrors(fieldErrors);

      setLoading(false);
    } finally {
      setLoading(false);
    }
  };
  const handleRegister = () => {
    if (validateStep2()) {
      signUp();
    }
  };
    const languageConfig = {
  fr: {
    flag: Img1,
  },
  en: {
    flag: Img,
  }
};
const availableLanguages = (process.env.REACT_APP_LANGUAGES).split(",").map((lang) => lang.trim()).filter(Boolean);


const validatePhone = () => {
  if (!phoneNumber) {
    setErrors((prev) => ({
      ...prev,
      phoneNumber: languageData.phone_error,
    }));
    return;
  }

  const phone = parsePhoneNumberFromString(phoneNumber);

  if (!phone || !phone.isValid()) {
    setErrors((prev) => ({
      ...prev,
      phoneNumber: languageData.invalid,
    }));
  } else {
    removeError("phoneNumber");
  }
};

  return (
    <>
      <div
        className="header-element country-selector position-absolute top-0 end-0 p-3"
        style={{ zIndex: 1050 }}
      >
        <a  data-interaction="languages_dropdown"
          aria-label="anchor"
          href="javascript:void(0);"
          data-bs-toggle="dropdown"
          data-bs-auto-close="outside"
        >
          <i className="bx bx-globe fs-3 text-black"></i>
        </a>
         <ul
  className="dropdown-position absolute main-header-dropdown dropdown-menu border-0 dropdown-menu-end"
  data-popper-placement="none"
>
  {availableLanguages.map((lang) => {
    const config = languageConfig[lang];

    if (!config) return null;

    return (
      <li key={lang}>
        <a
          href="#"
          data-interaction="lang"
          className="dropdown-item d-flex align-items-center"
          onClick={(e) => {
            e.preventDefault();
            setLanguage(lang);
          }}
        >
          <span className="avatar avatar-xs lh-1 me-2">
            <img src={config.flag} alt={lang} />
          </span>

          {languageData?.lang?.[lang]}
        </a>
      </li>
    );
  })}
</ul>
      </div>
      {/*  {loading ? (
        showSpinner && <Spinner />
      ) : ( */}
      <div className="page error-bg" id="particles-js">
        <div className="error-page">
          <div className="container-lg">
            <div className="row justify-content-center align-items-center authentication authentication-basic h-100">
              <div className="col-xxl-4 col-xl-5 col-lg-5 col-md-6 col-sm-8 col-12">
                <div className="my-5 d-flex justify-content-center">
              
                    <img src={logo} alt="logo" className="desktop-logo" />
                    <img src={logo1} alt="logo" className="desktop-dark" />
                
                </div>
                <div
                  className="card custom-card rectangle2"
                  style={{
                    boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
                    width: "120%",
                  }}
                >
                  <div className="card-body p-sm-5 p-3 rectangle3">
                    <div className="text-center">
                      <h4 className="mb-1 fs-17" style={{ color: "grey" }}>
                        {languageData.title}
                      </h4>
                      {Object.values(errors).filter(Boolean).length > 0 && (
                        <div className="alert alert-danger mb-3">
                          {Object.values(errors)
                            .filter(Boolean)
                            .map((msg, i) => (
                              <div key={i}>{msg}</div>
                            ))}
                        </div>
                      )}

                      <div
                        className="btn-list d-flex flex-column gap-3 overflow-hidden"
                        style={{ height: "auto" }}
                      >
                        <AnimatePresence mode="wait">
                          {step === 1 && (
                            <motion.div
                              key="form1"
                              variants={slideVariants}
                              initial="hidden"
                              animate="visible"
                              exit="exit"
                              transition={{ duration: 0.5 }}
                            >
                              <form>
                                <div className="form-group text-start mt-4">
                                  <label htmlFor="exampleInputEmail1">
                                    {languageData.email}
                                  </label>
                                  <input
                                  name="email"
                                    type="email"
                                    className="form-control mt-2 w-100"
                                    id="exampleInputEmail1"
                                    aria-describedby="emailHelp"
                                    value={email}
                                    onChange={(e) => {
                                      setEmail(e.target.value);
                                      removeError("email");
                                    }}
                                  />
                                  {errors.email && (
                                    <div className="text-danger mt-1 fs-14">
                                      {errors.email}
                                    </div>
                                  )}
                                </div>
                                <div className="form-check text-start mt-5">
                                  <input
                                  name="terms_signup"
                                    className="form-check-input mt-1"
                                    type="checkbox"
                                    id="defaultCheck1"
                                    onChange={(e) => {
                                      setTermsChecked(e.target.checked);
                                      removeError("terms");
                                    }}
                                    style={{ cursor: "pointer" }}
                                  />
                                  <label
                                    className="form-check-label fs-16 me-1"
                                    htmlFor="defaultCheck1"
                                  >
                                    {languageData.terms.term1}
                                  </label>
                                  <a  data-interaction="terms"
                                    href="#"
                                    style={{
                                      textDecoration: "underline",
                                      color: "grey",
                                      fontSize: "16px",
                                    }}
                                  >
                                    {languageData.terms.term2}
                                  </a>
                                  {errors.terms && (
                                    <div className="text-danger mt-1 fs-14">
                                      {errors.terms}
                                    </div>
                                  )}
                                </div>
                                <button  data-interaction="continue_inscription_button"
                                  type="button"
                                  className="btn btn-primary mt-2"
                                  style={{
                                    backgroundColor: "#FF6347",
                                    borderColor: "#FF6347",
                                    width: "100%",
                                  }}
                                  onClick={handleContinueInscription}
                                >
                                  {languageData.button1}
                                </button>
                                <div className="form-group form-check text-center fs-14 mt-2">
                                  <a  data-interaction="back_to_signin"
                                    href="/portal/signin"
                                    style={{
                                      textDecoration: "underline",
                                      color: "grey",
                                      fontSize: "14px",
                                    }}
                                  >
                                    {languageData.signin}
                                  </a>
                                </div>
                              </form>
                            </motion.div>
                          )}

                          {step === 2 && (
                            <motion.div
                              key="form2"
                              variants={slideVariants}
                              initial="hidden"
                              animate="visible"
                              exit="exit"
                              transition={{ duration: 0.5 }}
                            >
                              <div className="text-start mb-3">
                                <button  data-interaction="back_to_first_step"
                                  type="button"
                                  onClick={() => setStep(1)}
                                  style={{
                                    background: "none",
                                    border: "none",
                                    color: "#9d6aec",
                                    cursor: "pointer",
                                  }}
                                >
                                  <FaArrowLeft size={18} />
                                </button>
                              </div>
                              <form>
                                <div className="form-group text-start mt-4">
                                  <label htmlFor="name">
                                    {languageData.pseudo}
                                  </label>
                                  <input
                                  name="pseudo"
                                    type="text"
                                    className="form-control mt-2 w-100 p-2"
                                    id="name"
                                    value={pseudo}
                                    onChange={(e) => {
                                      setPseudo(e.target.value);
                                      removeError("pseudo");
                                    }}
                                  />
                                  {errors.pseudo && (
                                    <div className="text-danger mt-1 fs-14">
                                      {errors.pseudo}
                                    </div>
                                  )}
                                </div>
                                <div className="form-group text-start mt-4 position-relative">
                                  <label htmlFor="password">
                                    {languageData.password}
                                  </label>
                                  <input
                                  name="password"
                                    type={showPassword ? "text" : "password"}
                                    className="form-control mt-2 w-100p-2"
                                    id="password"
                                    onChange={(e) =>
                                      setPassword(e.target.value)
                                    }
                                  />
                                  <span
                                    onClick={() =>
                                      setShowPassword(!showPassword)
                                    }
                                    style={{
                                      position: "absolute",
                                      right: "10px",
                                      top: "71%",
                                      transform: "translateY(-50%)",
                                      cursor: "pointer",
                                      color: "#555",
                                    }}
                                  >
                                    {showPassword ? (
                                      <RiEyeOffLine size={15} />
                                    ) : (
                                      <RiEyeLine size={15} />
                                    )}
                                  </span>
                                  {errors.password && (
                                    <div className="text-danger mt-1 fs-14">
                                      {errors.password}
                                    </div>
                                  )}
                                </div>
                                <div className="form-group text-start mt-4">
                                  <label htmlFor="password">
                                    {languageData.phone}
                                  </label>
                                  <PhoneInput
                                    defaultCountry="us"
                                    value={phoneNumber}
                                    name="phone"
                                    onChange={(value, country) => {
                                      setPhoneNumber(value);
                                      setCountryData(country);
                                      if (
                                        /^\+?[1-9]\d{7,14}$/.test(
                                          value.replace(/\s/g, ""),
                                        )
                                      ) {
                                        removeError("phoneNumber");
                                      }
                                    }}
                                     onBlur={validatePhone}
                                    className="form-control p-0 mt-2"
                                    style={{
                                      height: "37px",
                                      border: "1px solid #dee2e6",
                                      borderRadius: "0.375rem",
                                    }}
                                    inputStyle={{
                                      height: "36px",
                                      border: "none",
                                      backgroundColor: "transparent",
                                      boxShadow: "none",
                                      paddingLeft: "8px",
                                    }}
                                    countrySelectorStyleProps={{
                                      buttonStyle: {
                                        border: "none",
                                        borderRight: "1px solid #dee2e6",
                                        borderRadius: "0.375rem 0 0 0.375rem",
                                        backgroundColor: "transparent",
                                        height: "34px",
                                        display: "flex-end",
                                        alignItems: "flex-end",
                                        justifyContent: "center",
                                        padding: "0 10px",
                                      },
                                    }}
                                  />
                                  {errors.phoneNumber && (
                                    <div className="text-danger mt-1 fs-14">
                                      {errors.phoneNumber}
                                    </div>
                                  )}
                                </div>

                                <div className="text-start mt-4">
                                  <label className="block text-gray-600 mb-1">
                                    {languageData.birthdate}
                                  </label>
                                  <div className="grid grid-cols-3 gap-2 m-0">
                                    <select  name="day"
                                      className="w-16  border rounded bg-white"
                                      style={{ color: "grey" }}
                                      value={birthdate.day}
                                      onChange={(e) => {
                                        setBirthdate({
                                          ...birthdate,
                                          day: e.target.value,
                                        });

                                        removeError("birthdate");
                                      }}
                                    >
                                      <option value="">
                                        {languageData.birthdate_placeholder.day}
                                      </option>
                                      {Array.from({ length: 31 }, (_, i) => (
                                        <option key={i + 1} value={i + 1}>
                                          {i + 1}
                                        </option>
                                      ))}
                                    </select>

                                    <select  name="month"
                                      className="w-24  border rounded bg-white"
                                      style={{ color: "grey" }}
                                      value={birthdate.month}
                                      onChange={(e) =>
                                        setBirthdate({
                                          ...birthdate,
                                          month: e.target.value,
                                        })
                                      }
                                    >
                                      <option value="" >
                                        {
                                          languageData.birthdate_placeholder
                                            .month
                                        }
                                      </option>
                                      {[
                                        `${languageData.birthdate_placeholder.months.Jan}`,
                                        `${languageData.birthdate_placeholder.months.Feb}`,
                                        `${languageData.birthdate_placeholder.months.Mar}`,
                                        `${languageData.birthdate_placeholder.months.Apr}`,
                                        `${languageData.birthdate_placeholder.months.May}`,
                                        `${languageData.birthdate_placeholder.months.Jun}`,
                                        `${languageData.birthdate_placeholder.months.Jul}`,
                                        `${languageData.birthdate_placeholder.months.Aug}`,
                                        `${languageData.birthdate_placeholder.months.Sep}`,
                                        `${languageData.birthdate_placeholder.months.Oct}`,
                                        `${languageData.birthdate_placeholder.months.Nov}`,
                                        `${languageData.birthdate_placeholder.months.Dec}`,
                                      ].map((month, index) => (
                                        <option
                                          key={index + 1}
                                          value={index + 1}
                                        >
                                          {month}
                                        </option>
                                      ))}
                                    </select>

                                    <input
                                    name="year"
                                      type="number"
                                      className="w-24 border rounded bg-white m-0"
                                      style={{ color: "grey" }}
                                      placeholder={
                                        languageData.birthdate_placeholder.year
                                      }
                                      min="1900"
                                      max={new Date().getFullYear()}
                                      value={birthdate.year}
                                      onChange={(e) => {
                                        const value = e.target.value;

                                        if (value.length <= 4) {
                                          setBirthdate({
                                            ...birthdate,
                                            year: value,
                                          });
                                        }
                                      }}
                                    />
                                  </div>
                                  {errors.birthdate && (
                                    <p className="text-danger mt-1 fs-14">
                                      {errors.birthdate}
                                    </p>
                                  )}
                                </div>
                                <div className="text-start mt-4">
                                  <a  data-interaction="sponsorship_collapse_signup"
                                    href="#"
                                    className="text-decoration-none fs-14"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#sponsorshipCollapse"
                                    aria-expanded="false"
                                    aria-controls="sponsorshipCollapse"
                                    onClick={(e) => e.preventDefault()}
                                    style={{
                                      color: "#9d6aec",
                                    }}
                                  >
                                    {languageData.have_sponsorship_code}
                                  </a>

                                  <div
                                    className="collapse m-0"
                                    id="sponsorshipCollapse"
                                  >
                                    <input
                                      type="text"
                                      className="form-control mt-2 w-100 sponsorship_code"
                                      placeholder={
                                        languageData.enter_sponsorship_code
                                      }
                                      name="sponsorship_code"
                                      value={sponsorshipCode}
                                      onChange={(e) =>
                                        setSponsorshipCode(e.target.value)
                                      }
                                    />
                                  </div>
                                </div>

                                <button  data-interaction="register_button"
                                  type="button"
                                  className="btn btn-primary mt-3"
                                  style={{
                                    backgroundColor: "#FF6347",
                                    borderColor: "#FF6347",
                                    width: "100%",
                                  }}
                                  onClick={handleRegister}
                                >
                                  {languageData.button2}
                                </button>

                                <div className="form-group form-check text-center fs-14 mt-2">
                                  <a  data-interaction="back_to_siginin"
                                    href="/portal/signin"
                                    style={{
                                      textDecoration: "underline",
                                      color: "grey",
                                      fontSize: "14px",
                                    }}
                                  >
                                    {languageData.signin}
                                  </a>
                                </div>
                              </form>
                            </motion.div>
                          )}
                        </AnimatePresence>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* )} */}
      {/* Spinner Overlay */}
      {loading && (
        <div className="spinner-overlay">
          <Spinner />
        </div>
      )}
    </>
  );
};

export default Signup;
